import React from 'react'
import CustomAppScreen from '../components/common/CustomAppScreen'
import { useFlow } from '../stackflow/stackflow'
import FadeInBanner from '../components/common/FadeInBanner'
import { getGroupCode, identify } from '../api/identify'
import PageMainIdentify from '../components/pageMain/PageMainIdentify'
import { PageCode } from '../stackflow/activities'
import SafeAreaBottom from '../components/base/SafeAreaBottom'

const MainPage: React.FC = () => {
  const { replace } = useFlow()
  const [isLoginFailed, setIsLoginFailed] = React.useState(false)

  const handleIdentify = async (groupCode: string) => {
    if (!groupCode) {
      setIsLoginFailed(true)
      return
    }

    const identified = await identify(groupCode)

    if (identified) {
      replace(PageCode.FEED, { groupCode })
    } else {
      setIsLoginFailed(true)
    }
  }

  React.useEffect(() => {
    const code = getGroupCode()
    if (!code) return

    const timer = setTimeout(() => {
      replace(PageCode.FEED, { groupCode: code }, { animate: false })
    }, 1200)

    return () => {
      clearTimeout(timer)
    }
  }, [])

  return (
    <CustomAppScreen appBar={{ border: false }}>
      <FadeInBanner />
      <PageMainIdentify onIdentify={handleIdentify} hasError={isLoginFailed} />
      <SafeAreaBottom />
    </CustomAppScreen>
  )
}

export default MainPage
